import { CustomLandingPageContainer } from "@containers/verification-service-details/verification-service-details-tab-container/verification-service-details-theming-tab/theming-landing-page-tab-container/custom-landing-page-container/custom-landing-page-container";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { PageLevelTypes } from "@enums/page-level-types";
import { RedirectUrlOriginTypes } from "@enums/redirect-url-origin-types";
import { BaseRedirectUrl } from "@idw-types/redirect-url-information";

type CustomLandingPagesContainerProps = {
    isDisabled: boolean;
    showOriginBadge: boolean;
    pageLevel: PageLevelTypes;
    labelWidth: LabelWidthTypes;
    layout: LayoutTypes;
    customRedirectUrlsWithOriginalIndex: Array<BaseRedirectUrl>;
    handleRemoveRedirect: (index: number, redirectUrlOrigin: RedirectUrlOriginTypes) => void;
    handleCustomRedirectChangeAtIndex: (newRedirectUrl: string, index: number, redirectUrl: string, redirectUrlOrigin: RedirectUrlOriginTypes) => void;
}

export const CustomLandingPagesContainer = (props: CustomLandingPagesContainerProps) => {
    const {
        isDisabled,
        showOriginBadge,
        customRedirectUrlsWithOriginalIndex,
        pageLevel,
        labelWidth,
        layout,
        handleRemoveRedirect,
        handleCustomRedirectChangeAtIndex
    } = props;
    return <div>

        {customRedirectUrlsWithOriginalIndex.map((item, index) => (
            <CustomLandingPageContainer
                isTheming={false}
                showOriginBadge={showOriginBadge}
                key={`theming-landing-page-${item.url}-${index}-container`}
                index={item.index}
                redirectUrl={item.url}
                redirectUrlOrigin={item.redirectUrlOrigin}
                isDisabled={isDisabled || !item.isEditable}
                axnuiContent={null}
                axnuiLayout={null}
                layout={layout}
                labelWidth={labelWidth}
                inheritedAXNUIContent={null}
                inheritedAXNUILayout={null}
                validationErrors={null}
                pageLevel={pageLevel}
                handleRemoveRedirect={handleRemoveRedirect}
                handleRedirectChangeAtIndex={handleCustomRedirectChangeAtIndex}
                updateAXNUIContentPropertyValue={() => { }}
                updateAXNUILayoutPropertyValue={() => { }}
            />
        ))
        }
    </div>;
}